import apiClient from './apiClient';
import { TEMPLATES_ENDPOINT, SUGGESTIONS_ENDPOINT } from '../utils/agentTemplates';

// SuperAdmins have no client of their own; the optional clientId scopes a request to one.
const withClient = (clientId) => (clientId ? `?clientId=${encodeURIComponent(clientId)}` : '');

/** The shared library plus the caller's own templates. */
export const fetchTemplates = async (clientId) => {
	const response = await apiClient.get(`${TEMPLATES_ENDPOINT}${withClient(clientId)}`);
	return response.data;
};

export const createTemplate = async (payload, clientId) => {
	const response = await apiClient.post(`${TEMPLATES_ENDPOINT}${withClient(clientId)}`, payload);
	return response.data;
};

export const updateTemplate = async (id, payload, clientId) => {
	const response = await apiClient.put(`${TEMPLATES_ENDPOINT}/${id}${withClient(clientId)}`, payload);
	return response.data;
};

export const deleteTemplate = async (id, clientId) => {
	await apiClient.delete(`${TEMPLATES_ENDPOINT}/${id}${withClient(clientId)}`);
};

/**
 * Creates an agent from a template.
 * @param {string} id template id
 * @param {{variables: Object<string,string>, agentChooserId?: string, dashboardId?: string}} body
 * @returns {Promise<{agent: Object, dashboardAttached: boolean}>}
 */
export const instantiateTemplate = async (id, body, clientId) => {
	const response = await apiClient.post(`${TEMPLATES_ENDPOINT}/${id}/instantiate${withClient(clientId)}`, body);
	return response.data;
};

/** The server's message for a failed request (it returns plain text for 400/404/409). */
export const templateErrorMessage = (error, fallback) => {
	const data = error?.response?.data;
	if (typeof data === 'string' && data.trim()) return data;
	if (typeof data?.message === 'string' && data.message.trim()) return data.message;
	return fallback;
};

/** How many pending suggestions the caller's client has (the sidebar badge). */
export const fetchSuggestionCount = async () => {
	const response = await apiClient.get(`${SUGGESTIONS_ENDPOINT}/count`);
	return response.data?.count ?? 0;
};

export const dismissSuggestion = async (id) => {
	await apiClient.post(`${SUGGESTIONS_ENDPOINT}/${id}/dismiss`);
};
